<template>
    <transition name="el-fade-in-linear">
        <div class="mask" v-show="state">
            <div class="flex">
                <div class="explain" :style="mainObj.style">
                    <div class="explain_close2 el-icon-close" @click="hide()"></div>
                    <div class="explain_title" :style="mainObj.titleStyle">{{mainObj.title}}</div>
                    <div class="explain_content" :style="mainObj.contentStyle">
                        <div v-if="isSupply">
                            <div>本渠道商品不发货地区：新疆、西藏、甘肃、青海、内蒙古、云南、宁夏、海南、香港、台湾、澳门。</div>
                            <br/>
                            <p style="color:#e18700">注：请谨慎选择，如不发货地区下单成功则需要另补运费！敬请谅解</p>
                        </div>
                        <div v-else-if="query.id==9">
                            <div>该专区产品为香港直邮、保税仓等跨境商品，购买者需填写姓名、身份证号。</div>
                            <br/>
                            <p>发货说明（现货商品）</p>
                            <p> 香港直邮：商品发货时间为2个工作日内；</p>
                            <p>保税仓：商品发货时间为2个工作日内；</p>
                            <p>其他国家/地区：商品发货时间为3-4个工作日。</p>
                            <br/>
                            <p style="color:#e18700"> 注：跨境商品均不带中文标签。</p>
                        </div>
                        <div v-else-if="query.id==15">
                            <p>运动大牌专区狂欢福利，尺码、库存有限，售完即止。</p>
                            <br/>
                            <p style="color:#e18700"> 注：该区为福利活动商品，鞋服尺码库存都是有限的，是否有货以详情页显示为准</p>
                        </div>
                        <div v-else-if="query.id==77">
                            <p>本产品为福利品，发货后不支持拦截和无理由退换(质量问题可更换)。请谨慎下单！</p>
                            <br/>
                            <p style="color:#e18700"> 注：微唯宝仓库直发</p>
                        </div>
                        <div v-else-if="query.id==78">
                            <p><b>售后政策</b></p>
                            <p>1、签收7天内退货，质量问题运费商家承担，</p>
                            <p>2、签收7天内无理由退货/拒收、拦截等客户自身问题导致的客户需承担来回产生运费</p>
                            <p>3、3个月内质量问题免费换新，寄回运费客户承担，补发运费品牌仓库承担。</p>
                            <p>4、一年内免工费维修(客户承担运费)</p>
                            <p>5、收到货后超7天的订单，不支持退货退款。</p>
                        </div>
                        <div v-else>
                            <p>虚拟产品不支持退换、请谨慎下单。</p>
                            <br/>
                            <p style="color:#e18700"> 注：该区为虚拟产品，一旦下单，不支持退换</p>
                        </div>
                        <br/>
                    </div>
                    <div class="explain_time">{{timeNum>0 ? `${timeNum}秒后自动关闭` : ''}}</div>
                </div>
            </div>
        </div>
      </transition>
</template>
<script>
export default{
    data(){
        return {
            state : false,
            mainObj : {
                title : '说明',
                content : '',
            },
            timer : null,
            timeNum : 9,
            query : {},
            isSupply : '',//是否是渠道
        }
    },
    watch:{
        $route:{
            deep: true,
            handler(newVal,oldVal){
                this.isSupply = '';
                this.query = newVal.query
                this.timeNum = 9
                clearInterval(this.timer);
                if(this.timeNum>0){
                    let idArr = ['9','15','77','78']
                    let direct = localStorage.getItem('ys_overseas_direct_mail');
                    if(this.query.nav_type=='4'){
                        idArr.push(this.query.id)
                    }
                    if(newVal.path=='/seatSelect'){
                        this.query.id = 'film'
                        idArr.push(this.query.id)
                    }
                    this.state = idArr.includes(this.query.id)&&(!direct||direct.indexOf(this.query.id+',')==-1);
                    if(this.state){
                        clearInterval(this.timer);
                        this.timer = setInterval(()=>{
                            this.timeNum--;
                            if(this.timeNum<=0){
                                clearInterval(this.timer);
                                this.state = false;
                            }
                        },1000)
                    }
                }
            },
            immediate: true
        },
    },
    props:{
        
    },
    mounted(){
        this.$bus.$on("announcementNotice", (res) => {
            this.isSupply = res;
            let direct = localStorage.getItem('ys_overseas_direct_mail');
            this.state = !direct||direct.indexOf(this.isSupply+',')==-1;
            if(this.state){
                this.timeNum = 9
                clearInterval(this.timer);
                this.timer = setInterval(()=>{
                    this.timeNum--;
                    if(this.timeNum<=0){
                        clearInterval(this.timer);
                        this.state = false;
                    }
                },1000)
            }
        });
    },
    beforeCreate(){
        localStorage.removeItem('ys_overseas_direct_mail')
    },
    methods:{
        show(params={}){
            for(var key in params){
                this.mainObj[key] = params[key];
            }
            this.state = true;
        },
        hide(){
            this.state = false;
            let direct = localStorage.getItem('ys_overseas_direct_mail')||''
            localStorage.setItem('ys_overseas_direct_mail',direct+(this.isSupply||this.query.id)+',')
        }
    }
}
</script>
<style lang="scss" scoped>
.mask{
    position: fixed;
    left: 0;
    top:0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background-color: #0000006e;
    transition: all .3s;
}
.flex{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.explain{
    background-color: #fff;
    padding: 25px;
    padding-left: 50px;
    border-radius: 12px;
    width: 500px;
    // min-height: 30%;
    // max-height: 60%;
    position: relative;
    &_title{
        text-align: center;
        font-size: 26px;
        padding-bottom: 30px;
    }
    &_content{
        color: #555;
    }
    &_time{
        color:  var(--theme-color);
        bottom: 10px;
        text-align: center;
    }
    &_close2{
        position: absolute;
        right: 5px;
        top: 5px;
        font-size: 24px;
        color: #999;
        cursor: pointer;
    }
}
</style>
